{
  "title": "Demandes",
  "subtitle": "Messages du formulaire de contact public et de Obtenir de l’aide dans le portail.",
  "newCount": "{{count}} nouvelles",
  "statusNew": "Nouvelle",
  "statusHandled": "Traitée",
  "statusSpam": "Spam",
  "loadError": "Impossible de charger les demandes",
  "goneTitle": "Cette demande a disparu",
  "goneBody": "Le lien pointait vers une demande qui n’est plus là — elle a peut-être été supprimée, ou l’adresse a été mal saisie.",
  "emptyNewTitle": "Rien en attente",
  "emptyNewBody": "Tout ce qui était en attente a été traité.",
  "emptyOtherTitle": "Rien ici",
  "emptyOtherBody": "Aucune demande marquée {{status}}.",
  "handledBy": "traitée par {{name}}",
  "reply": "Répondre",
  "markHandled": "Marquer comme traitée",
  "markSpam": "Spam",
  "markNew": "Rouvrir",
  "markedVerb": "{{name}} marquée {{verb}}.",
  "updateError": "Impossible de mettre à jour cette demande.",
  "replyTitle": "Répondre à {{name}}",
  "replyBody": "Votre réponse",
  "sendReply": "Envoyer la réponse",
  "replySent": "Réponse envoyée à {{email}}.",
  "replyError": "Impossible d’envoyer cette réponse.",
  "getHelp": "Obtenir de l’aide",
  "getHelpTitle": "Obtenir de l’aide",
  "getHelpHint": "Dites-nous ce dont vous avez besoin. Le personnel OnBrand Mail répondra par e-mail.",
  "messageLabel": "Message",
  "messagePlaceholder": "Ce que vous essayez de faire, et ce qui vous en empêche.",
  "send": "Envoyer",
  "helpSent": "Message envoyé. Nous répondrons par e-mail.",
  "helpRateLimited": "Quelques messages en peu de temps — réessayez dans quelques minutes.",
  "helpSendError": "Impossible d’envoyer. Veuillez réessayer.",
  "noAccessTitle": "Pas d’accès aux demandes",
  "noAccessBody": "Les messages du site public sont lus par le personnel OnBrand Mail.",
  "footerNote": "Les demandes arrivent du formulaire de contact du site public et de Obtenir de l’aide dans le portail. Les messages du site ne sont pas encore des clients — un locataire est créé depuis l’écran Locataires dès qu’il y a quelque chose à intégrer. L’aide du portail nomme déjà l’organisation.",
  "replySendsFrom": "Envoi depuis OnBrand Mail vers {{email}}. Leur réponse revient dans la boîte de support.",
  "verbHandled": "traitée",
  "verbSpam": "spam",
  "verbReopened": "à nouveau nouvelle"
}
